import { makeStyles } from "../../_core/components";
import { useLogo } from "../../brand/hooks";

const AuthHeader = () => {
  const classes = useStyles();
  const logo = useLogo();
  return <div className={classes.header}>{Boolean(logo) && <img alt="logo" src={logo} data-testid="logo" />}</div>;
};

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",

    width: "100%",
    padding: theme.spacing(3),
    paddingBottom: 0,
    height: 200,

    "& > img": {
      display: "block",
      height: 100,
      objectFit: "contain",
    },
  },
}));

export default AuthHeader;
